export default Object.freeze({
  VisitError: 1,
  NotFinalized: 2,
  WithoutVisitCertification: 3,
});
